import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin } from 'antd'
import MemberRibbon from './ribbon'
import MemberDetail from './detail'

export default function Member() {
  const [userData, setUserData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isUserDetailVisible, setIsUserDetailVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getUserData = () => {
    axios.post('/admin/user/list/get', { 
      is_vip: 1,
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setUserData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'users': response.data.users
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getUserData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const viewDetail = (oid) => {
    setIsUserDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">会员用户</div>
            <MemberRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue}
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>手机号</th>
                    <th>性别</th>
                    <th>出生日期</th>
                    <th>年龄</th>
                    <th>加入时间</th>
                  </tr>
                </thead>

                <tbody>
                  {userData.users && (userData.users.length > 0 ? (userData.users.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { viewDetail(item.oid) }}>
                      <td>
                        <div className='public-main-style2-tuwen'>
                          <img src={item.avatar_url || '/images/avatar.png'} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.name || '-'}</span>
                        </div>
                      </td>
                      <td>{item.phone || '-'}</td>
                      <td>{item.gender || '-'}</td>
                      <td>{item.date_birth || '-'}</td>
                      <td>{item.age ? item.age + '岁' : '-'}</td>
                      <td>{item.create_time}</td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='6'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={userData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isUserDetailVisible && <MemberDetail
          data={propsData}
          isOpen={isUserDetailVisible} 
          isCancel={() => { setIsUserDetailVisible(false) }} 
          getUserData={getUserData} 
        />}
      </Spin>
    </div>
  )
}
